const themeColor = {
	// --primary-color: #edf2f8;
	// --secondary-color: #313bac;
	// --black-color: #030303;
	// --lightGray-color: #e4e4e4;
	// --gray-color: #6b7688;
	// --brown-color: #46364a;
	// --white-color: #ffffff;
	blackColor: '#030303',
	secondaryColor: '#313bac',
	skillImageContainerHover: '#fef4f5',

	workFilterItemHoverBackground: '#ffffff',
	selectedTextColor: '#ffffff',
	unSelectedTextColor: '#000',
	selectedBackgroundColor: '#313bac',
	unSelectedBackgroundColor: '#ffffff',
};

export default themeColor;
